<!-- 显示申请单 -->
<template>
  <div class="app-container">
    <Table
      ref="tableRef"
      :showSearchIcon="true"
      :data="tableData"
      :columns="columns"
      :total="total"
      :loading="loading"
      :searchAttrName="searchAttrName"
      rowKey="outInRecordsId"
      childRowKey="productRecordsId"
      :isExpand="true"
      :isSelect="true"
      :childColumns="childColumns"
      :pageSize="20"
      height="calc(100vh - 210px)"
      :showPagination="true"
      tableName="warehouseDateList"
      exportDataUrl="/outInputRecords/selectOutInputRecords"
      @expandOpen="handleExpandOpen"
      @onSearch="handleSearch"
    >
    </Table>
  </div>
</template>

<script setup>
import Table from "@/components/Element/Table";
import { onActivated, ref } from "vue";
import { getCustomTableCols } from "@/tableColumn";
import {
  selectOutInRecordsDetail,
  selectOutInputRecords,
  selectProductInventoryByProductRecordsId,
  selectProductRecordsByApplicationFormId,
  selectProductRecordsByOutInRecordsId,
} from "@/api/warehouse/warehouseDate";
import { isNull } from "@/utils/fangerUtils";
import { confirmBoxFun } from "@/utils/msgBox";
import useApplicationFormStore from "@/store/modules/applicationForm";
import { useRouter } from "vue-router";

import useCacheStore from "@/store/modules/cache";
const cacheStore = useCacheStore();
const { getProductById } = cacheStore;
const applicationFormStore = useApplicationFormStore();

const router = useRouter();

/**仅支持 Vue 3.3+  配置name 为了是 keep-alive :include 生效 */
defineOptions({
  name: "warehouseDateList",
});

const tableRef = ref(null);
const tableData = ref([]);
const total = ref(0);
const loading = ref(false);
const searchAttrName = [];

const handleSearch = (data) => {
  loading.value = true;
  selectOutInputRecords(data)
    .then((res) => {
      tableData.value = res.data;
      total.value = res?.pageParam?.totleInfo ? res.pageParam.totleInfo : 0;
    })
    .catch(() => {})
    .finally(() => {
      loading.value = false;
    });
};

// 查询展开数据
const handleExpandOpen = (row) => {
  if (!isNull(row.childTableData)) return;
  row.childTableLoading = true;
  let completeNum = childColumns.find((item) => item.prop == "completeNum");
  let inCompleteNum = childColumns.find((item) => item.prop == "incompleteNum");
  if (row.status === "1") {
    completeNum.label = "已入数量";
    inCompleteNum.label = "未入数量";
  } else {
    completeNum.label = "已出数量";
    inCompleteNum.label = "未出数量";
  }
  selectProductRecordsByOutInRecordsId(row.outInRecordsId)
    .then((res) => {
      const childTableData = [];
      res.data.forEach((item) => {
        childTableData.push({
          ...getProductById(item.productId),
          ...item,
        });
      });
      row.childTableData = childTableData;
    })
    .catch(() => {})
    .finally(() => {
      row.childTableLoading = false;
    });
};

// 修改
const goDetail = (event, row) => {
  applicationFormStore.updateData = row;
  router.push({
    path: "/outInRecords/warehouseProRecord",
    query: { proId: row.productRecordsId },
  });
};

onActivated(() => {
  // 修改成功后表格触发重新搜索
  if (applicationFormStore.updateSuccessFlag) {
    applicationFormStore.updateSuccessFlag = false;
    tableRef.value && tableRef.value.onSearch();
  }
});
const handleControlDisabled = (row) => {
  return row.usageType !== "1";
};
const columns = getCustomTableCols([
  "name",
  "projectName",
  "contractNo",
  "applicant",
  "outInType",
  "recipient",
  "outInWarehouseStatus",
  "inWarehouse",
  "outWarehouse",
  "operateTime",
  "operatorName",
]);

const childColumns = getCustomTableCols([
  "productName",
  "productNum",
  "completeNum",
  "incompleteNum",
  "productType",
  "supplierp",
  "supplierModel",
  "recipient",
  "internalModel",
  "usageType",
  {
    label: "操作",
    prop: "action",
    type: "action",
    search: false,
    action: [
      {
        control: "button",
        controlName: "明细",
        controlType: "success",
        controlText: true,
        controlDisabled: handleControlDisabled,
        controlFun: goDetail,
      },
    ],
  },
]);
</script>

<style lang="scss" scoped></style>
